import React, { useState } from "react";
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import { formatDate } from "../../utils/dateFormat";
import Events from "./Events";

function EventsAccordion(props) {
    const [open, setOpen] = useState(false);
    const [editData, setEditData] = useState()
    const [editClicked, setEditClicked] = useState(false)
    return (
        <>

            {props.data?.length > 0 && props.data[0]?.event_name ? (
                <div>
                    <div className="cName d-flex justify-between items-center">
                        <p className="my-0">
                            {props.data[0].event_name}
                        </p>
                        <sl-tooltip content="Edit events">
                            <SlIcon library='lucide' className='cursor-pointer' name='pencil' onClick={() => {setEditData(props.data[0]);setEditClicked(true)}} />
                        </sl-tooltip>
                    </div>
                    <div className="cContact d-flex justify-between items-center">
                        <div>
                            <p className="my-0">{formatDate(props.data[0]?.event_date)}</p>
                            <p className="my-0">{props.data[0]?.description}</p>
                        </div>
                        <div>
                            {!open ? (
                                <SlIcon
                                    library="lucide"
                                    name="chevron-down"
                                    className="text-black hover:cursor-pointer text-base"
                                    onClick={() => setOpen(true)}
                                ></SlIcon>
                            ) : (
                                <SlIcon
                                    library="lucide"
                                    name="chevron-up"
                                    className="text-black hover:cursor-pointer text-base"
                                    onClick={() => setOpen(false)}
                                ></SlIcon>
                            )}
                        </div>
                    </div>

                </div>
            ) : (
                "-"
            )}
            {open &&
                props.data?.slice(1)?.map((poc) => {
                    return (
                        <div className="contactModal">
                            <div className="mt-2 d-flex justify-between items-center">
                                <p className="my-0 text-xs font-semibold capitalize">
                                    {poc.event_name}
                                </p>
                                <sl-tooltip content="Edit events">
                                    <SlIcon library='lucide' className='cursor-pointer' name='pencil' onClick={() => {setEditData(poc);setEditClicked(true)}} />
                                </sl-tooltip>
                            </div>
                            <div>
                                <p className="my-0">{formatDate(poc.event_date)}</p>
                                <p className="my-0">{poc.description}</p>
                            </div>
                        </div>
                    );
                })}
        
        {editClicked && <Events data={editData} flag={"edit"} show={editClicked} setShow={setEditClicked}  loadData={props.loadData} />}
        
        </>
    );
}

export default EventsAccordion;
